import script from "./BookingModalsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingModalsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./BookingModalsComponent.vue?vue&type=style&index=0&id=b55afce6&lang=css"

const __exports__ = script;

export default __exports__